import { IAidasOrganisation } from 'app/shared/model/ainnotateservice/aidas-organisation.model';

export interface IAidasCustomer {
  id?: number;
  name?: string;
  description?: string | null;
  aidasOrganisation?: IAidasOrganisation;
}

export const defaultValue: Readonly<IAidasCustomer> = {};
